module.exports = __webpack_public_path__ + "img/2085.831e94cb.gif";